/* biome-ignore-all lint/suspicious/noExplicitAny: legacy data structure */
import type { Response, CollectionResponse, PageQueryParams } from "@/types/global"
import { HttpRequest } from "@/utils/request"

export interface IdiomSearchParams extends PageQueryParams {
  search?: string
}

export interface IdiomApiParams {
  page: number
  limit: number
  search?: string
}

export const idiomService = {
  list(params: IdiomApiParams) {
    return HttpRequest.get("v1/idioms", {
      searchParams: params as any,
    }).json<CollectionResponse>()
  },

  detail(id: number) {
    return HttpRequest.get(`v1/idioms/${id}`).json<Response>()
  },
}
